<template>
    
        <div class="text-left  pb30 pt30 holderBtnBack">
            <router-link to="/" class="btnBack redColor">
                <img src="../assets/images/btn-back.png"  v-show="currentRouteName !== 'Home'"> Home
            </router-link>
        </div>  
         
        <ul class="topNavMenu" v-if="userAuthentication" >
            <li class="username"> Hi, <span>  {{ $store.state.username}} </span>  </li>
            <li>
                <img src="../assets/images/image-profile.png">
            </li>
            <li>
                <div class="divider">|</div>
            </li>
            <li>
                <button  @click="$store.commit('logout')" >Sign Out</button>
            </li>
        </ul>
        <hr>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
    
    data() {
        return {
            user_data: [],
        };
    },
    computed:{
        ...mapGetters(['userAuthentication']),
        currentRouteName() {
            return this.$route.name;
        }
    },
    methods: {
        ...mapActions(['closeSession']),

        getUserInfo(name){

            //=================================
            //Get cookie called ?  
            //=================================  
            let checkUser = null
            let cname = name
            var name = cname + "=";
            var ca = document.cookie.split(";");
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == " ") {
                c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                checkUser = c.substring(name.length, c.length);
                }
            }
  
            this.user_data = JSON.parse(checkUser);
        }
    },
    created(){
        this.getUserInfo('user_info')
    }
}
</script>

<style>

</style>